"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M17.855 9.132l1.99-3.514a.416.416 0 00-.145-.562.395.395 0 00-.55.149l-2.016 3.56A12.109 12.109 0 0012 7.649c-1.863 0-3.595.4-5.134 1.116L4.85 5.205a.398.398 0 00-.551-.149.414.414 0 00-.146.562l1.99 3.514C2.71 11.028.385 14.57 0 18.714h24c-.384-4.145-2.71-7.686-6.145-9.582zM6.49 15.28c-.557 0-1.006-.46-1.006-1.025 0-.567.452-1.025 1.006-1.025.556 0 1.006.46 1.006 1.025A1.014 1.014 0 016.49 15.28zm11.018 0c-.557 0-1.006-.46-1.006-1.025 0-.567.452-1.025 1.006-1.025.556 0 1.005.46 1.005 1.025a1.014 1.014 0 01-1.006 1.025z" }), "Android");
//# sourceMappingURL=Android.js.map